import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Weather = () => {
  const [weatherData, setWeatherData] = useState(null);

  useEffect(() => {
    const fetchWeather = async () => {
      const apiKey = '34344d31d6c4ef6a4d563820d925f940';
      const city = 'Gold Coast';
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=${apiKey}`;

      try {
        const response = await axios.get(url);
        const temp = Math.round(response.data.main.temp);
        const description = response.data.weather[0].description;
        setWeatherData({ temp, description });
      } catch (error) {
        console.error('Error fetching the weather data:', error);
      }
    };

    fetchWeather();
  }, []);

  if (!weatherData) {
    return <div>Loading weather...</div>;
  }

  return (
    <div className='weather'>
      {weatherData.description}, {weatherData.temp}°C
    </div>
  );
};

export default Weather;
